import React from 'react';
import PropTypes from 'prop-types';

import listFormat from 'utils/listFormat';
import { SHIPPING_RESTRICTIONS } from 'utils/shipping';
import styles from './ShippingRestrictions.module.scss';

const formatRestrictions = (restrictions) => {
  const list = restrictions.map((hash) => SHIPPING_RESTRICTIONS[hash]);
  return listFormat.format(list);
};

const ShippingRestrictions = ({ restrictions }) => {
  if (restrictions?.length) {
    const countriesNames = formatRestrictions(restrictions);
    return (
      <p className={styles.shippingRestrictionsText}>
        This bundle cannot be delivered to {countriesNames} due to shipping
        restrictions.
      </p>
    );
  }
  return <div className={styles.shippingRestrictionsSpace} />;
};

ShippingRestrictions.propTypes = {
  restrictions: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ShippingRestrictions;
